var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 19C33.5 18.1716 32.8284 17.5 32 17.5C31.1716 17.5 30.5 18.1716 30.5 19L33.5 19ZM30.9393 44.0607C31.5251 44.6464 32.4749 44.6464 33.0607 44.0607L42.6066 34.5147C43.1924 33.9289 43.1924 32.9792 42.6066 32.3934C42.0208 31.8076 41.0711 31.8076 40.4853 32.3934L32 40.8787L23.5147 32.3934C22.9289 31.8076 21.9792 31.8076 21.3934 32.3934C20.8076 32.9792 20.8076 33.9289 21.3934 34.5147L30.9393 44.0607ZM30.5 19L30.5 43L33.5 43L33.5 19L30.5 19Z",
    fill: "#FF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/ScrollDown.985faf726e0351733c8d2820dace38ea.svg";
export { ForwardRef as ReactComponent };